import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { AuthUser, LoginResponse } from "@autoflow/types";

type AuthContextValue = {
  user: AuthUser | null;
  completeLogin: (response: LoginResponse) => void;
  logout: () => void;
};
const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user,setUser] = useState<AuthUser|null>(() => {
    try { return JSON.parse(localStorage.getItem("autoflow.user") ?? "null") as AuthUser|null; }
    catch { return null; }
  });
  const value = useMemo<AuthContextValue>(() => ({
    user,
    completeLogin(response) {
      localStorage.setItem("autoflow.accessToken", response.accessToken);
      localStorage.setItem("autoflow.refreshToken", response.refreshToken);
      localStorage.setItem("autoflow.user", JSON.stringify(response.user));
      setUser(response.user);
    },
    logout() {
      ["autoflow.accessToken","autoflow.refreshToken","autoflow.user"].forEach(key=>localStorage.removeItem(key));
      setUser(null);
    }
  }),[user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const value=useContext(AuthContext);
  if(!value) throw new Error("useAuth must be used inside AuthProvider");
  return value;
}
